<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row">
  <div class="col-12">
    <div class="tile opacity-container" [class.active]="situations()?.length">
      <h5 class="zero-text p-bigger-bold mb-3">
        {{ 'child-onboarding.situation-checklist.headline' | transloco }}
      </h5>
      <web-design-system-notification color="blue" [isDismissible]="false" size="mid" class="d-block mb-3">
        <h5 class="zero-text p-base-bold mb-3">
          <web-design-system-icon name="scale" /> {{ 'child-onboarding.situation-checklist.notification-headline' | transloco }}
        </h5>
        <div class="zero-text p-small-reg" [innerHTML]="'child-onboarding.situation-checklist.notification-text' | transloco"></div>
      </web-design-system-notification>

      <div class="zero-text p-base-reg mb-4" data-zid="situation-hint">
        {{ 'child-onboarding.situation-checklist.situation-hint' | transloco }}
      </div>
      <div class="mb-4"><web-design-system-select [items]="situationItems()" (selectItem)="selectSituation($event)" /></div>

      @if (selectedSituation(); as situation) {
        @if (!situation.isValid) {
          <div class="zero-text p-base-reg course-red mb-4" data-zid="situation-error">
            {{ 'child-onboarding.situation-checklist.situation-error' | transloco }}
          </div>
        } @else {
          <div class="zero-text p-base-reg mb-3">
            {{ 'child-onboarding.situation-checklist.checklist-hint' | transloco }}
          </div>
          <div class="mb-3">
            <web-design-system-checkbox
              [isChecked]="checklist()[UnderageOnboardingLegitimizationDocument.BIRTH_CERTIFICATE]"
              (isCheckedChange)="toggleChecklistItem(UnderageOnboardingLegitimizationDocument.BIRTH_CERTIFICATE, $event)"
              [style]="'blue'"
            >
              <span class="zero-text p-base-reg">
                {{ 'child-onboarding.situation-checklist.checklist-item.birth-certificate' | transloco }}
              </span>
            </web-design-system-checkbox>
          </div>
          @for (doc of situation.documents; track $index) {
            @if (doc.type !== UnderageOnboardingLegitimizationDocument.BIRTH_CERTIFICATE) {
              <div class="mb-3">
                <web-design-system-checkbox
                  [style]="'blue'"
                  [isChecked]="checklist()[doc.type]"
                  (isCheckedChange)="toggleChecklistItem(doc.type, $event)"
                >
                  <span class="zero-text p-base-reg">{{ doc.name }}</span>
                </web-design-system-checkbox>
              </div>
            }
          }

          <div class="mb-3">
            <web-design-system-checkbox
              [isChecked]="checklist()[InitialCheckBoxType.customerIdLegalGuardian2]"
              (isCheckedChange)="toggleChecklistItem(InitialCheckBoxType.customerIdLegalGuardian2, $event)"
              [style]="'blue'"
            >
              <div
                class="zero-text p-base-reg"
                [innerHTML]="'child-onboarding.situation-checklist.checklist-item.customer-id' | transloco"
              ></div>
            </web-design-system-checkbox>
          </div>
          <div class="mb-3">
            <web-design-system-checkbox
              [style]="'blue'"
              [isChecked]="checklist()[InitialCheckBoxType.allGermanResidenceTax]"
              (isCheckedChange)="toggleChecklistItem(InitialCheckBoxType.allGermanResidenceTax, $event)"
            >
              <span class="zero-text p-base-reg">{{ 'child-onboarding.situation-checklist.checklist-item.all-german' | transloco }}</span>
            </web-design-system-checkbox>
          </div>
          <div class="mb-3">
            <web-design-system-checkbox
              [style]="'blue'"
              [isChecked]="checklist()[InitialCheckBoxType.passport]"
              (isCheckedChange)="toggleChecklistItem(InitialCheckBoxType.passport, $event)"
            >
              <span class="zero-text p-base-reg">{{ 'child-onboarding.situation-checklist.checklist-item.passport' | transloco }}</span>
            </web-design-system-checkbox>
          </div>

          <div class="d-flex justify-content-center mb-3">
            <web-design-system-button [disabled]="!formValid()" (click)="submit()" data-zid="btn-submit">
              {{ 'child-onboarding.situation-checklist.btn-start' | transloco }}
            </web-design-system-button>
          </div>
        }
      }
    </div>
    <div class="tile opacity-container" [class.active]="situations()?.length">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="zero-text p-bigger-med">{{ 'child-onboarding.situation-checklist.how-to.headline' | transloco }}</h5>
        <web-design-system-icon-button (click)="collapse()" type="grey-light" size="small" [icon]="collapsed() ? 'chevron' : 'chevron-2'" />
      </div>
      @if (!collapsed()) {
        @for (item of ['person', 'account', 'identification', 'legal-guardian-2', 'open']; track $index) {
          <div class="d-flex align-items-center gap-half justify-content-start mb-3" [class.mt-3]="$index === 0">
            <div class="list-index">{{ $index + 1 }}</div>
            <div>
              <div class="zero-text p-base-bold">
                {{ 'child-onboarding.situation-checklist.how-to.' + item + '.title' | transloco }}
              </div>
              <div class="zero-text p-base-reg">
                {{ 'child-onboarding.situation-checklist.how-to.' + item + '.subtitle' | transloco }}
              </div>
            </div>
          </div>
        }
        <div class="zero-text p-base-reg" [innerHTML]="'child-onboarding.situation-checklist.how-to.general' | transloco"></div>
      }
    </div>
  </div>
</div>
